<div class="header-container" [class.sidebar-collapsed]="isSidebarCollapsed">
  <div class="desktop-header">
    <div class="header-content">
      <div class="user-avatar" (click)="toggleProfileDropdown()">
        <span class="avatar-initials">{{ userInitials }}</span>
      </div>
      <ng-container *ngTemplateOutlet="profileDropdown; context: { condition: isProfileDropdownOpen && !isMobileView() }"></ng-container>
    </div>
  </div>
  <div class="mobile-header">
    <img src="/assets/122.png" alt="Logo" class="mobile-logo" />
    <div class="mobile-header-content">
      <div class="user-avatar" (click)="toggleProfileDropdown()">
        <span class="avatar-initials">{{ userInitials }}</span>
      </div>
      <ng-container *ngTemplateOutlet="profileDropdown; context: { condition: isProfileDropdownOpen && isMobileView() }"></ng-container>
    </div>
    <div class="mobile-menu-icon" (click)="toggleMobileNav()">
      <img *ngIf="!isMobileNavOpen" src="assets/images/menu.svg" alt="Menu" />
      <span *ngIf="isMobileNavOpen">Close</span>
    </div>
  </div>
</div>

<!-- Profile Dropdown Template (reused for desktop and mobile) -->
<ng-template #profileDropdown let-condition="condition">
  <div class="profile-dropdown" *ngIf="condition">
    <div class="profile-info">
      <div class="user-details">
        <div class="user-email">{{ userEmail }}</div>
      </div>
    </div>
    <div class="logout-section" (click)="logout()">
      <div class="logout-icon">
        <img src="/assets/images/logout.svg" alt="Logout Icon" />
      </div>
      <div class="logout-text">Logout</div>
    </div>
  </div>
</ng-template>
